var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransition = function SvgTransition(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    fillRule: "evenodd",
    d: "m11.404 2.073 2.375 1.511a.486.486 0 0 1 0 .815l-2.375 1.512a.464.464 0 0 1-.647-.154.5.5 0 0 1-.07-.254V4.412c-1.153.117-2.06 1.085-2.111 2.281l-.003.107v2.4l-.002.116c-.054 1.659-1.286 3.012-2.867 3.217-.2.842-.941 1.467-1.826 1.467C2.841 14 2 13.14 2 12.08s.84-1.92 1.878-1.92c.863 0 1.59.595 1.81 1.405 1.072-.189 1.895-1.12 1.944-2.258l.002-.107V6.8l.002-.116c.057-1.722 1.382-3.115 3.05-3.236V2.48c0-.265.21-.48.47-.48.087 0 .173.025.248.073M4.817 12.08a.95.95 0 0 0-.939-.96.95.95 0 0 0-.939.96c0 .53.42.96.94.96a.95.95 0 0 0 .938-.96",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransition);
export { ForwardRef as ReactComponent };